import Vue from 'vue'
import VueRouter from 'vue-router'
import LayoutIndex from '../layout/LayoutIndex'
import home from './home'
import lesson from './lesson'
import newsDetail from './news'
Vue.use(VueRouter)

const routes = [
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  {
    path: '',
    component: LayoutIndex,
    redirect: '',
    children: [
      {
        path: '',
        name: 'index',
        component: () => import(/* webpackChunkName: "index" */ '../views/index/index.vue')
      }
    ]
  },
  home,
  lesson,
  newsDetail
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
